import * as yup from 'yup'

import questionnaireResponsesSchema from './questionnaireResponsesSchema'

const palFormSchema = (t) =>
	yup.tuple([questionnaireResponsesSchema(t), yup.object(), yup.object()])

export default palFormSchema
